import { render, staticRenderFns } from "./imageData.vue?vue&type=template&id=2ca72095&scoped=true"
import script from "./imageData.vue?vue&type=script&lang=js"
export * from "./imageData.vue?vue&type=script&lang=js"
import style0 from "./imageData.vue?vue&type=style&index=0&id=2ca72095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca72095",
  null
  
)

export default component.exports